<template>
  <v-app>
    <div class="fixed-top res" style="background-color:white">
       <div class="row" style="padding:10px;background-color:#05665f">
           <div class="col-lg-2 col-md-2 col-sm-12">
               <img src="../../assets/Csquad_logo.png" style="width:80px;height:80px;background-color:white;padding:10px;border-radius:5px;" />
           </div>

           <div class="col-lg-7 col-md-7 col-sm-12" style="padding-top:15px;">
               <v-text-field style="background-color:whitesmoke;height:56px;border-radius:2px;" outline v-model="search" label="Search Medicines / Healthcare Products"></v-text-field>
               <v-btn large flat dark style="margin-bottom:-12px;">Order Medicine</v-btn>
               <v-btn large flat dark style="margin-bottom:-12px;">Healthcare Products</v-btn>
               <v-btn large flat dark style="margin-bottom:-12px;">Diagnostic Tests</v-btn>
           </div>

           <div class="col-lg-3 col-md-3 col-sm-12" style="padding-top:5px;">
               <v-btn style="padding:30px;" depressed color="#0d6c67" dark>Don't have an account?<br/>Get Started ▼</v-btn>
               <br/><span style="color:white;padding-right:35px;" class="txt"><v-icon style="padding-top:10px;" color="white">local_offer</v-icon> Offers</span>
               <span style="color:white;padding-right:35px;" class="txt"><v-icon style="padding-top:10px;" color="white">emoji_emotions</v-icon> User</span>
               <span style="color:white;" class="txt"><v-icon style="padding-top:10px;" color="white">shopping_cart</v-icon> Cart</span>
           </div>
       </div>
     </div>

     <div class="fixed-top man" style="background-color:white">
     <b-navbar toggleable="lg" type="light" variant="light" style="height:auto;">  
       <b-navbar-brand><img src="../../assets/Csquad_logo.png" style="width:80px;cursor: pointer;" @click="main()"/></b-navbar-brand>
       <b-nav-item style="margin-top:-10px" v-if="$store.state.cartCount > 0">
             <v-badge
        color="red"
        right
        overlap
        size="0.2px"
      >
        <span slot="badge">{{$store.state.cartCount}}</span>
        <v-btn icon class="ma-0">
          <v-icon @click="cartList()">add_shopping_cart</v-icon>
         </v-btn>
      </v-badge>
       </b-nav-item>
       <b-nav-item style="margin-top:-10px" v-if="$store.state.cartCount == 0">
        <v-btn icon class="ma-0">
          <v-icon>add_shopping_cart</v-icon>
         </v-btn>
       
       
       </b-nav-item>
      
       <b-nav-item style="margin-top:-10px" v-if="loggedInUserID != null">
         <v-menu
        v-model="menu1"
        transition="fade-transition"
        :close-on-content-click="true"
        :nudge-width="150"
      >
             <v-icon slot="activator" :size="25">person_outline</v-icon>
             <v-card>
               <v-list style="background-color:#2970ce">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <avatar :size="32" :username="loggedInUserName"></avatar>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title style="font-size:13px;color:white">{{loggedInUserName}}</v-list-tile-title>
                <v-list-tile-sub-title style="font-size:13px;color:white">{{role}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-list v-if="role=='Customer'">
            
            <v-list-tile to="/myProfile" style="padding:0px;margin-top:0px">
              <v-list-tile-action>
                <v-icon small color="primary">account_circle</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">My Profile</v-list-tile-title>
            </v-list-tile>
            <v-divider style="padding:0px;margin-top:0px"></v-divider>

            

            <v-list-tile to="/myOrder" style="padding:0px;margin-top:-10px">
              <v-list-tile-action>
                <v-icon small color="primary">dvr</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">My Orders</v-list-tile-title>
            </v-list-tile>
            <v-divider style="padding:0px;margin-top:0px"></v-divider>

            <v-list-tile to="/cartList" class="txt_dec" style="padding:0px;margin-top:-10px">
              <v-list-tile-action>
                <v-icon small color="primary">favorite_border</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">My Wishlist</v-list-tile-title>
            </v-list-tile>
            <v-divider style="padding:0px;margin-top:0px"></v-divider>

            <v-list-tile @click="changePassword()" style="padding:0px;margin-top:-10px">
              <v-list-tile-action>
                <v-icon small color="primary">vpn_key</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">Password change</v-list-tile-title>
            </v-list-tile>

            <v-divider style="padding:0px;margin-top:0px"></v-divider>
            <v-list-tile @click.stop="logOutDialog = true" style="padding:0px;margin-top:-10px">
              <v-list-tile-action>
                <v-icon small color="primary">power_settings_new</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">Log out</v-list-tile-title>

              <v-dialog v-model="logOutDialog" max-width="290">
                <v-card style="padding: 20px !important ; border-radius: 10px">
                  <!-- <v-card-title class="headline">Logout</v-card-title>

                  <v-card-text>Are you sure you want to logout from bluesky ?</v-card-text> -->
                  <h4 style="text-align:center;font-size:20px">Logout</h4>

                  <v-card-text style="text-align:center">Are you sure you want to logout from CSQUAD ?</v-card-text>

                  <v-card-actions>
                    <v-btn style="padding-left:70px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list-tile>
          </v-list>
          <v-list v-if="role!='Customer'">
            <v-list-tile @click="dashboard()" style="padding:0px;margin-top:0px">
              <v-list-tile-action>
                <v-icon small>dashboard</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">Dashboard</v-list-tile-title>
            </v-list-tile>

            <v-divider style="padding:0px;margin-top:0px"></v-divider>
            <v-list-tile @click.stop="logOutDialog = true" style="padding:0px;margin-top:-20px">
              <v-list-tile-action>
                <v-icon small>power_settings_new</v-icon>
              </v-list-tile-action>
              <v-list-tile-title style="font-size:13px">Log out</v-list-tile-title>

              <v-dialog v-model="logOutDialog" max-width="290">
                <v-card style="padding: 20px !important ; border-radius: 10px">
                  <!-- <v-card-title class="headline">Logout</v-card-title>

                  <v-card-text>Are you sure you want to logout from bluesky ?</v-card-text> -->
                  <h4 style="text-align:center;font-size:20px">Logout</h4>

                  <v-card-text style="text-align:center">Are you sure you want to logout from CSQUAD ?</v-card-text>

                  <v-card-actions>
                    <v-btn style="padding-left:70px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list-tile>
          </v-list>
             </v-card>
         </v-menu>
       </b-nav-item>
           <b-nav-item style="margin-top:-10px" v-if="loggedInUserID == null">
             <v-icon :size="25" @click="login()">person</v-icon>
           </b-nav-item>
       <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

       <b-collapse id="nav-collapse" is-nav>
         <b-navbar-nav class="ml-auto" style="text-align:center">
           <b-nav-item>
             <span @click="homeBtn()" class="navitem" style="color:#212121;font-size:15px;">Home</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span @click="aboutBtn()" class="navitem" style="color:#212121;font-size:15px">About</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span @click="productBtn()" class="navitem" style="color:#212121;font-size:15px">Products</span>
             <v-divider></v-divider>
           </b-nav-item>
           <!-- <b-nav-item >
             <span @click="blogBtn()" class="navitem" style="color:#212121;font-size:15px">Blogs</span>
             <v-divider></v-divider>
           </b-nav-item> -->
           <b-nav-item >
             <span @click="testimonialBtn()" class="navitem" style="color:#212121;font-size:15px">Testimonials</span>
             <v-divider></v-divider>
           </b-nav-item>
           <!-- <b-nav-item >
             <span @click="teamBtn()" class="navitem" style="color:#212121;font-size:15px">Our Team</span>
             <v-divider></v-divider>
           </b-nav-item> -->
           <b-nav-item >
             <span class="navitem" style="color:#212121;font-size:15px" @click="partnerBtn()">Our Partners</span>
             <v-divider></v-divider>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem" @click="wishBtn()" style="color:#212121;font-size:15px">My Wishlist</span>
           </b-nav-item>
           <b-nav-item >
             <span class="navitem" @click="vendorBtn()" style="color:#212121;font-size:15px">Vendor Register</span>
           </b-nav-item>
         </b-navbar-nav>
       </b-collapse>
     </b-navbar>
     </div>
     
       
    
  <v-content>
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view></router-view>
      </transition>
      <div class="icon-bar">
  <a @click.stop="menu2=true" target="_blank" class="whatsapp"><img src="https://img.icons8.com/material/24/ffffff/whatsapp--v1.png"/></a>      
  <a href="https://www.facebook.com/c.squad.3/" target="_blank" class="facebook"><img src="https://img.icons8.com/color/24/000000/facebook-circled.png"/></a>
  <a href="https://twitter.com/CSQUAD80413663" target="_blank" class="twitter"><img src="https://img.icons8.com/ios-filled/24/000000/twitter.png"/></a>
  <a href="https://www.linkedin.com/in/c-squad-b01768211/" target="_blank" class="linkedin"><img src="https://img.icons8.com/color/24/000000/linkedin.png"/></a>
  <a href="https://www.instagram.com/csquad143/" target="_blank" class="youtube"><img src="https://img.icons8.com/material/24/000000/instagram-new--v1.png"/></a>
      </div>
  </v-content>

         <!-- ==================================================== FOOTER ================================================ -->

     <footer>
                <div class="ftr">
            <div class="container" style="padding-bottom:60px;padding-top:60px;">

              <div class="row" style="color:#212121">
                <div class="col-sm-12 col-lg-4 mb-lg-0">
                  <img src="../../assets/Csquad_logo.png" style="width:100px;height:140px" />

                  <p style="padding-top:25px;color:#212121;font-family: 'Nanum Gothic', sans-serif;font-size:15px">Call us :</p>
                  <h5 style="font-family: 'Nanum Gothic', sans-serif;font-weight:bold;color:#E4573D;margin-top:-7px">(+91) 74399 23445</h5>
                  <!-- <h5 style="font-family: 'Nanum Gothic', sans-serif;font-weight:bold;color:#E4573D;margin-top:5px">+91 6289408122</h5> -->
                  
                </div>

                <div class="col-sm-12 col-lg-2 mb-lg-0">
                  <h5 style="font-weight:bold;font-family: 'Nanum Gothic', sans-serif">Product Categories</h5>
                  <p class="hvr" style="padding-top:25px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="essential()">Covid Essentials</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="medicine()">Medicines</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="food()" >Home Cooked Food</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="device()">Devices</p>
                </div>

                <div class="col-sm-12 col-lg-2 mb-lg-0">
                  <h5 style="font-weight:bold;font-family: 'Nanum Gothic', sans-serif">Our Company</h5>
                  <p class="hvr" style="padding-top:25px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="aboutBtn()">About Us</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="terms()" >Terms of Service</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="privacy()" >Privacy Policy</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="shipping()" >Shipping Policy</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="returns()" >Return Policy</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="cancellation()" >Cancellation Policy</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="refund()" >Refund Policy</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="blogBtn()">Our Blogs</p>
                  <p class="hvr" style="margin-top:-5px;font-family: 'Nanum Gothic', sans-serif;color:#212121" @click="aboutBtn()">Contact Us</p>
                </div>

                <div class="col-sm-12 col-lg-4 mb-lg-0">
                  <!-- <img src="../../assets/map.png" style="width:350px;height:200px" /> -->
                  <!-- <div class="wpb_map_wraper"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.167777119563!2d88.34902531443406!3d22.572827438652055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277a69e51331d%3A0x4cf4d2e706ef0acd!2sZenith%20Educational%20Services!5e0!3m2!1sen!2sin!4v1618739775624!5m2!1sen!2sin" width="100%" height="250" style="border: 0px;" allowfullscreen="" loading="lazy"></iframe></div> -->
                  <div class="wpb_map_wraper">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.870272917444!2d88.46263911427468!3d22.62131903688308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89fe42ba734b5%3A0x49099362e41b132!2sAstra%20Towers%2C%20Action%20Area%20IIC%2C%20Newtown%2C%20New%20Town%2C%20West%20Bengal%20700135!5e0!3m2!1sen!2sin!4v1626447882843!5m2!1sen!2sin" width="100%" height="250" style="border:0;" allowfullscreen="" loading="lazy"></iframe>  
                  </div>
                  <!-- <p style="padding-top:25px;color:#212121;font-family: 'Nanum Gothic', sans-serif;font-size:15px">
                    Follow us on social networks
                  </p>
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/facebook-new.png"/>&nbsp;
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/twitter.png"/>&nbsp;
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/instagram-new.png"/>&nbsp;
                  <img class="mysocial" src="https://img.icons8.com/color/48/000000/linkedin.png"/> -->
                </div>

                  
                </div>
              </div>
            </div>
        

        <div style="background-color:#F8F8F8">
          <div class="container" style="padding-top:0px;padding-bottom:0px;">
          <v-card-title style="color:#212121">
             © {{ new Date().getFullYear() }}, CSQUAD. All rights reserved.
             <v-spacer></v-spacer>
             <v-spacer></v-spacer>
             Develop & Maintained by &nbsp;
        <a
          href="#" target="_blank" style="color:#4E97FD"
        >Maclean</a>
          </v-card-title>
            </div>
        </div>
    </footer>

    <div>
      <v-menu
        min-width = 300
        top
        v-model="menu2"
        :close-on-click="false"
        :close-on-content-click="false"
        :nudge-top="60"
        offset-x
      >
        <template v-slot:activator="{ on }">
          <v-fab-transition>
            <v-btn
             style="display:none"
              v-model="fab"
              v-on="on"
              color='green darken-1'
              @click="fab = !fab; menu2 = false"
              dark
              
              bottom
              right
              fab
            >
              <v-icon>comment</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-fab-transition>
        </template>
        <v-card style="margin-top:150px;">
          <v-list dark class="chat-header">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>CSquad</v-list-tile-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-btn
                  icon
                  @click="fab = !fab; menu2 = false"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-container class="chat-background">
            <v-layout row wrap >
              <v-flex class="text-xs-right" xs12 mb-4>
                <v-chip class="chip-chat ">
                  Hello, how can we help you? <v-icon right>done_all</v-icon>
                </v-chip>
              </v-flex>
              <v-flex xs10>
                <v-text-field
                  single-line
                  color="teal"
                  class="my-input"
                  v-model="text"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-btn
                  large
                  class="teal--text txt_dec"
                  icon
                  @click="fab = !fab; menu = false"
                  :href="apilink"
                  target="_blank"
                >
                  <v-icon large>send</v-icon>
                </v-btn>
               </v-flex>
             </v-layout>  
          </v-container>
        </v-card>  
      </v-menu>   
    </div>


    <v-dialog v-model="logDialog" lazy width="350px">
      <v-card style="border-radius:0px;background-color:#212121" flat>
        <v-container>
          <h5 class="white--text" style="text-align:center">Login & Registration</h5>

          <div style="text-align:center;padding-top:25px">
            <v-btn depressed small color="#e53935" dark @click="register()">REGISTRATION</v-btn>
            <v-btn depressed small color="#e53935" dark @click="login()">LOGIN</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
   
  </v-app>
</template>

<script>

import Avatar from "vue-avatar";
//import config from "./../../config.json";
//import vuetifyToast from "vuetify-toast";
//import { AuthStr } from "../Auth.js";
/* import carousel from 'vue-owl-carousel'; */
const DEFAULT_TRANSITION = "fade";
export default {
  components: {
    Avatar
  },
  data() {
    return {
      tab: null,
      search: null,
      valid: true,
      listOne: false,
      passwordShow: false,
      menu: false,
      menu1: false,
      darkMode: false,
      dateModel: false,
      enquiryDialog: false,
      logOutDialog: false,
      loggedInUserName: sessionStorage.loggedInUserName,
      loggedInUserID: sessionStorage.loggedInUserID,
      role: sessionStorage.roles,
      transitionName: DEFAULT_TRANSITION,
      isLoading: false,
      destinations: null,
      selectedDestination: null,
      logDialog: false,
      btnSave: false,
      src: "https://aimroindia.com/aimro/api/ProfilePic/" + sessionStorage.loggedInUserID,
      wishList: this.$store.state.wish,
      fab: false,
    fav: true,
    menu2: false,
    message: false,
    hints: true,
    phone: '917439923445',
    text: "",
    apilink: "",

      home: true,
      about: false,
      blog: false,
      testimonial: false,
      team: false,
      product: false,

      end: 'demo',

      form: {
        email: null
      },

      categoryList: [],

      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
      },

    };
  },
  watch: {
		text(val) {
			this.apilink = 'http://';
      this.apilink += this.isMobile() ? 'api' : 'web';
      this.apilink += '.whatsapp.com/send?phone=' + this.phone + '&text=' + encodeURI(this.text);
		}
	},
  created: function () {
    this.apilink = 'http://';
    this.apilink += this.isMobile() ? 'api' : 'web';
    this.apilink += '.whatsapp.com/send?phone=' + this.phone + '&text=' + encodeURI("Hello!");

    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });
  },
  methods: {
    isMobile() {
      var check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    getdata() {
      this.end = this.$route.params.id;
    },

    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    logOut() {
      this.$store.dispatch("logout").then(() => {
        this.logOutDialog = false;
        this.menu1 = false;
        this.$router.push("/");
        window.location.reload();
      });
    },

    main() {
      this.$router.push("/");
    },

    wishBtn() {
      this.$router.push("/wishList");
    },
    
    login() {
      this.$router.push("/login");
    },
    vendorBtn() {
      this.$router.push("/vendorRegister");
    },
    cartList() {
      this.$router.push("/cartList");
    },

    dashboard() {
      this.$router.push("/_");
    },

    partnerBtn() {
      this.$router.push("/partners");
    },

    vendor() {
      this.$router.push("/vendorRegistration");
    },

    register() {
      this.$router.push("/registration");
    },
    privacy() {
      this.$router.push("/privacy");
    },
    terms() {
      this.$router.push("/terms");
    },
    returns() {
      this.$router.push("/returns");
    },
    shipping() {
      this.$router.push("/shipping");
    },
    cancellation() {
      this.$router.push("/cancellation");
    },
    refund() {
      this.$router.push("/refund");
    },
    essential() {
      sessionStorage.setItem("id", 5);
      this.$router.push(`/detail`);
    },
    food() {
      sessionStorage.setItem("id", 7);
      this.$router.push(`/detail`);
    },
    device() {
      sessionStorage.setItem("id", 6);
      this.$router.push(`/detail`);
    },
    medicine() {
      sessionStorage.setItem("id", 8);
      this.$router.push(`/detail`);
    },

    homeBtn() {
      this.$router.push("/");
      this.about = false;
      this.blog = false;
      this.testimonial = false;
      this.team = false;
      this.product = false;
      this.home = true;
    },

    aboutBtn() {
      this.$router.push("/aboutus");
      this.blog = false;
      this.testimonial = false;
      this.team = false;
      this.home = false;
      this.product = false;
      this.about = true;
    },

    blogBtn() {
      this.$router.push("/blog");
      this.about = false;
      this.testimonial = false;
      this.team = false;
      this.home = false;
      this.product = false;
      this.blog = true;
    },

    testimonialBtn() {
      this.$router.push("/testimonial");
      this.about = false;
      this.team = false;
      this.home = false;
      this.blog = false;
      this.product = false;
      this.testimonial = true;
    },

    teamBtn() {
      this.$router.push("/team");
      this.about = false;
      this.home = false;
      this.blog = false;
      this.testimonial = false;
      this.product = false;
      this.team = true;
    },
    productBtn() {
      this.$router.push("/categoryList");
      this.about = false;
      this.home = false;
      this.blog = false;
      this.testimonial = false;
      this.team = false;
      this.product = true;
    },

  },

  mounted() {
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Permanent+Marker&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Special+Elite&display=swap');
@import url('https://fonts.googleapis.com/css?family=Farro&display=swap');  
@import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300&display=swap');
@keyframes blink {
  from { background-color: purple; }
  to { background-color: red; }
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
.icon-bar {
    position: fixed;
    float: right !important;
    top: 80% !important;
    z-index: 1;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    right: 0% !important;
}

/* Style the icon bar links */
.icon-bar a {
  display: block;
  text-align: center;
  padding: 9px;
  transition: all 0.3s ease;
  color: white;
  font-size: 20px;
}
.facebook {
  background: #3B5998;
  color: white;
}
.whatsapp {
  background: rgb(45, 139, 45);
  color: white;
}

.twitter {
  background: #55ACEE;
  color: white;
}

.google {
  background: #dd4b39;
  color: white;
}

.linkedin {
  background: #007bb5;
  color: white;
}

.youtube {
  background: #bb0000;
  color: white;
}
.banner1 {
  background-image: url('../../assets/slider1.jpg');
  background-size: contain;

  height:450px;
}
.my-input.v-input .v-input__slot {
  border-radius: 100px;
}
.chat-background {
  background-color: #ECE5DD !important
}
.chat-header {
  background-color: #075E54 !important
}
.chip-chat {
  background-color: #DCF8C6 !important
}
.covid {
  font-family: 'Quicksand', sans-serif;
  font-weight: bold;
}
.header-top {
    background-color: green;
    color: #fff;
    width: 100%;
    padding: 6px;
    /* margin-bottom: 5px; */
}
.user {
  cursor: pointer !important;
  margin-top: -10px;
}
.v-tabs__item {
    align-items: center;
    color: inherit;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    justify-content: center;
    max-width: inherit;
    padding: 0px !important;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: normal;
}
.v-tabs__item {
    align-items: center;
    color: inherit;
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    justify-content: center;
    max-width: inherit;
    padding: 0px !important;
    text-decoration: none;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: normal;
}
.bgclr {
    width: 100%;
    height: 350px;
    background-image: linear-gradient(#7b1fa2, #e91e63);
}
.nvbr {
  background-color: white !important;
  padding: 0px !important;
}
.navitem:hover {
 color: #4E97FD !important;
}
.clr:hover {
  background-color: tomato !important;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.ss {
  border-radius: 5%;
  height: 60px !important;
}
.v-tabs__item {
  padding: 0px !important;
}
.ss1 {
  border-radius: 5%;
  height: 58px !important;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.near {
  top: -70px;
  position: relative;
}
.near1 {
  top: -70px;
  bottom: -30px;
  position: relative;
}
.txtcntr {
  text-align: center;
}
.mrgn {
  margin-top: 70px;
}
.pdng {
  padding-bottom: -25px !important;
}
h1.heading_1 {
  width: 100% !important;
}

.bg_clr {
  background-color: grey;
}

.heading_1 {
  font-family: 'Space Mono', monospace;
  text-align: center !important;
}
.menutxt {
  padding-right: 10px;
  font-family: 'Special Elite', cursive;
  font-weight: bold;
  font-size: 17px;
  text-align: center;
  margin-bottom: 0px;
}
.footertxt {
  font-family: 'Nanum Gothic', sans-serif;
  color: white !important;
  font-size: 16px;
}
.hq {
  border-style: solid;
    border-width: 1px;
    border-radius: .5rem;
    margin-left: .5rem;
    padding: .125rem .5rem;
    font-size: 12px !important;
}
.main_icon {
  text-align: center !important;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.hotel_name {
  font-family: 'Space Mono', monospace;
  font-weight: bold;
}
.hotel_name1 {
  font-family: 'Anton', sans-serif;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
	background: #fff !important;
  border-bottom: none !important;
}
td.hvr:hover {
  background-color: #fff !important;
  background: #fff !important;
  border-bottom: none !important;
}
.rate {
  height: 280px;
  border-radius: 4%;
  background-image: linear-gradient(#7b1fa2, #e91e63);
 /* background-color: #eeeeee; */
}
.yellowText {
    color: yellow;
}
.font12 {
    font-size: 12px;
    line-height: 12px;
}
.latoBold {
    font-weight: 700;
}
.sprite.discountIcon {
    width: 38px;
    height: 17px;
    background-position: -206px -73px;
}
.appendLeft5 {
    margin-left: 5px;
}
.sprite {
    background: url(//imgak.mmtcdn.com/pwa_v3/pwa_hotel_assets/web/hotelSprite-v4.png) no-repeat;
    display: inline-block;
    background-size: 400px 400px;
    font-size: 0px;
    flex-shrink: 0;
}
.font11 {
    font-size: 11px;
    line-height: 11px;
}
.discountText {
    display: inline-block;
    position: absolute;
    left: 12px;
    top: 2px;
}
.lineThrough {
  text-decoration: line-through;
}
.filtr {
  background-image: linear-gradient(#e91e63, #7b1fa2);
}
.free {
  text-align: center !important;
}
.aminity {
  width: 100%;
}
.aminities {
  width: 30%;
  float: left;
}
.v-sheet--offset {
  top: -50px;
  position: relative;
}
.sign {
  color:white !important;
}
tr {
  border-bottom: none !important;
}
.form-container {
  margin: 0px !important;
}
.ani {
  animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
.flashing_effect {
  background-image: linear-gradient(-90deg, #3751EE, #b32e25);
  padding: 0px 5px 0px 5px;
  font-size: 35px;
  /* animation-name: flashing;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite; */
}
::marker {
  color: white !important;
}

.vtbs  {
  padding: 0px !important;
}
@keyframes flashing{
  0% {
     opacity: 1.0;
  }
  25% {
     opacity: 0.6;
  }
  50% {
     opacity: 0.3;
  }
  75% {
     opacity: 0.6;
  }
  100% {
     opacity: 1.0;
  }
}
@media screen and (max-width: 768px) {
  .heading_1 {
    font-size: 14px;
  }
  .rspnsv {
    margin-bottom: 30px;
    height: auto;
  }
  ._hello {
    height: auto !important;
  }
  .res {
    display: none;
  }
  
}
@media screen and (max-width: 768px){
  .icon-bar {
    float:right !important;
    right: 2% !important;
  }
}
/* @media screen and (min-width: 768px) {
  .icon-bar {
    float:right !important;
    right: 1.5% !important;
  }
} */
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
.abc {
  overflow: hidden !important;
}
.ftr {
  /* background-image: url('../../assets/footer.png'); */
  background-color: #F8F8F8;
  background-size: cover !important;
}
.txt_dec {
  text-decoration: none !important;
}


.menu {  
  font: 14px/1.5 'Open Sans', sans-serif;
  margin: 0;
  padding: 0;
  list-style: none;
}

.menu a {
  display: block;
  color: #333;
  text-decoration: none;
}

.menu li {
  display:block;
  float: left;
  position: relative;
  color: #fff;
}

.menu li ul {
  position: absolute;
  left: 0;
  top: 20px;
  margin: 0;
  padding: 7px;
}

.menu li ul li {
  border-left: 2px solid;
  border-left-color: #FF3501;
  background: white;
  color: #333;
  transition: background .2s;
}

.menu li ul li:hover {
  background: white;
  color: #333;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-active {
  opacity: 0;
}
.mysocial {
  border-radius: 15px;
  transition: background 1s ease-out 100ms;
}

.mysocial:hover {
  background-color: green;
  border-radius: 15px;
  cursor: pointer;
}
</style>
